import IconWrapper from './IconWrapper';

const IconAssociate = IconWrapper({
  name: 'associate',
  source: (
    <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.75 12C15.75 13.6866 15.1315 15.2286 14.1088 16.4118C13.5674 16.303 13.0611 16.0971 12.6089 15.8129C13.6196 14.856 14.25 13.5016 14.25 12C14.25 10.4984 13.6196 9.144 12.6089 8.1871C13.0611 7.90295 13.5674 7.697 14.1088 7.58823C15.1315 8.77137 15.75 10.3135 15.75 12ZM9 6.75C9.20626 6.75 9.40974 6.7619 9.6098 6.78504C10.0554 6.32456 10.5595 5.92101 11.1101 5.58636C10.4462 5.36808 9.7369 5.25 9 5.25C5.27208 5.25 2.25 8.27208 2.25 12C2.25 15.7279 5.27208 18.75 9 18.75C9.7369 18.75 10.4462 18.6319 11.1101 18.4136C10.5595 18.079 10.0554 17.6754 9.6098 17.215C9.40974 17.2381 9.20626 17.25 9 17.25C6.10051 17.25 3.75 14.8995 3.75 12C3.75 9.10051 6.10051 6.75 9 6.75ZM9.75 12C9.75 9.10051 12.1005 6.75 15 6.75C17.8995 6.75 20.25 9.10051 20.25 12C20.25 14.8995 17.8995 17.25 15 17.25C12.1005 17.25 9.75 14.8995 9.75 12ZM15 5.25C11.2721 5.25 8.25 8.27208 8.25 12C8.25 15.7279 11.2721 18.75 15 18.75C18.7279 18.75 21.75 15.7279 21.75 12C21.75 8.27208 18.7279 5.25 15 5.25Z"
      />
    </svg>
  ),
});

export default IconAssociate;
